import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import Select from "react-select";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const Phase = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const dispatch = useDispatch();
  const [inputData, setInputData] = useState([]);
  const [primaryPhase, setPrimaryPhase] = useState([]);
  const [secondaryPhase, setSecondaryPhase] = useState([]);
  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);
    if (
      eventName === "primary_sector_phase" ||
      eventName === "secondary_sector_phase"
    ) {
      if (eventName === "primary_sector_phase") {
        setPrimaryPhase(event);
      } else {
        setSecondaryPhase(event);
      }
      if (event != null) {
        setInputData((prevState) => ({
          ...prevState,
          [eventName]: event["id"],
        }));
      } else {
        setInputData((prevState) => ({ ...prevState, [eventName]: null }));
      }
    } else {
      setInputData((prevState) => ({
        ...prevState,
        [event.target.name]: event.target.value,
      }));
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updatePhase = {
      userId: inputData.userId,
      primary_sector_phase: inputData.primary_sector_phase,
      secondary_sector_phase: inputData.secondary_sector_phase,
    };
    dispatch(updateProfleAction(inputData.userId, updatePhase));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const phase = {
        userId: props.profile.userId,
        primary_sector_phase: props.profile.primary_sector_phase,
        secondary_sector_phase: props.profile.secondary_sector_phase,
      };
      setInputData(phase);
    }

    if (Object.keys(props.phases).length > 0) {
      if (inputData.primary_sector_phase != null) {
        const primaryPhaseData = props.phases.find(
          (row) => row.id === inputData.primary_sector_phase
        );
        if (props.primarySectorId != null) {
          setPrimaryPhase(primaryPhaseData);
        } else {
          setPrimaryPhase(null);
        }
      }
      if (inputData.secondary_sector_phase != null) {
        const secondaryPhaseData = props.phases.find(
          (row) => row.id === inputData.secondary_sector_phase
        );
        if (props.secondarySectorId != null) {
          setSecondaryPhase(secondaryPhaseData);
        } else {
          setSecondaryPhase(null);
        }
      }
    }
  }, [
    props.profile,
    props.phases,
    props.primarySectorId,
    props.secondarySectorId,
  ]);
  return (
    <div className="row margin-row">
      <DialogLeavingPage
        showDialog={showDialogLeavingPage}
        setShowDialog={setCanShowDialogLeavingPage}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
        title={"Sector Phase"}
      />
      <div className="col-12 ">
        <div className="timeline-border-box">
          <h5>Sector Phase</h5>
          <div className="row">
            <div className="col-md-6 col-12  ">
              <label className="field-label" style={{ paddingTop: "3%" }}>
                Primary Sector Phase
              </label>
            </div>
            <div className="col-md-6 col-12 ">
              <Select
                id="primary_sector_phase"
                name="primary_sector_phase"
                value={
                  props.phases &&
                  props.phases.find(
                    (phase) => phase.id === inputData.primary_sector_phase
                  )
                }
                options={props.phases}
                getOptionLabel={(option) => option.phase}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "primary_sector_phase")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
                isDisabled={props.primarySectorId === null ? true : false}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "2%" }}>
              <label className="field-label">Secondary Sector Phase</label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="secondary_sector_phase"
                name="secondary_sector_phase"
                value={
                  props.phases &&
                  props.phases.find(
                    (phase) => phase.id === inputData.secondary_sector_phase
                  )
                }
                options={props.phases}
                getOptionLabel={(option) => option.phase}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "secondary_sector_phase")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
                isDisabled={
                  primaryPhase === null || props.secondarySectorId === null
                    ? true
                    : false
                }
              />
            </div>
          </div>{" "}
          <br />
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const phases = state.admin.phases;

  return {
    user: user,
    profile: profile,
    phases: state.admin.phases,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Phase);
